/**
 * Who can reach the Consciousness Companion — his rule: Silver membership and above.
 * Module 1 is an introduction open to everyone, so Bronze members walk through worksheets there
 * before they have a journal to write in; the prompts have to stay hidden for them.
 * Kept in one place so the tab, the page and the worksheet prompts can never disagree.
 */
export const COMPANION_MIN_TIER = 'silver';

const TIER_RANK = { everyone: 0, bronze: 1, silver: 2, gold: 3, platinum: 4 };

export const hasCompanion = (user) => {
  if (!user) return false;
  if (user.role === 'admin' || user.membership_tier === 'free_comp') return true;
  return (TIER_RANK[user.membership_tier] || 1) >= TIER_RANK[COMPANION_MIN_TIER];
};

export default hasCompanion;
